<div class="autocomplete-container" [class.has-results]="filteredOptions.length > 0">
  <div class="input-wrapper" [class.focused]="isFocused" [class.has-value]="searchQuery || optionSelected">
    <div *ngIf="optionSelected && searchQuery" class="selected-pill">
      <span class="pill-text truncate">{{ searchQuery }}</span>
      <button class="clear-btn" (click)="clearSelection($event)" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <input
      type="text"
      *ngIf="!optionSelected"
      [(ngModel)]="searchQuery"
      (input)="onSearch(searchQuery)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [placeholder]="placeHolder"
      class="search-input"
      #searchInput
    />

    <div class="actions">
      <button *ngIf="!optionSelected && searchQuery" class="icon-btn clear-search" (click)="clearSearch($event)" type="button">
        <i class="fas fa-times-circle"></i>
      </button>
      <button class="icon-btn toggle-btn" (click)="toggleDropdown($event)" type="button" [class.active]="filteredOptions.length > 0">
        <i class="fas fa-chevron-down"></i>
      </button>
    </div>
  </div>

  <div class="dropdown-panel" *ngIf="filteredOptions.length > 0">
    <ul class="autocomplete-list">
      <li
        *ngFor="let option of filteredOptions"
        (click)="onSelect(option)"
        [class.selected]="option === searchQuery"
        class="autocomplete-item"
        [ngClass]="{'no-data': option === 'No data found'}"
      >
        <i class="fas fa-search item-icon" *ngIf="option !== 'No data found'"></i>
        <span class="item-text">{{ option }}</span>
      </li>
    </ul>
  </div>
</div>
